import React, { Context, useReducer } from 'react';
import { commonAction } from '../types/commonActions';

export type baseContextType<T, U extends {}> = {
  state: T;
  dispatch: U;
};

export const createContext = <T extends {}, U extends { [key: string]: Function }>(
  reducer: (state: any, action: commonAction) => {},
  actions: U,
  initialState: T,
): { Context: Context<baseContextType<T, U>>; Provider: any } => {
  const defaultValue: baseContextType<T, U> = { state: initialState, dispatch: {} as U };
  const Context = React.createContext(defaultValue);
  const Provider = ({
    children,
    value = initialState,
  }: {
    children: React.ReactNode;
    value?: T;
  }) => {
    const [state, dispatchActions] = useReducer(reducer, value);

    const boundActions: { [key: string]: Function } = {};
    for (let key in actions) {
      boundActions[key] = actions[key](dispatchActions);
    }

    return (
      <Context.Provider
        value={{ state, dispatch: boundActions } as unknown as baseContextType<T, U>}
      >
        {children}
      </Context.Provider>
    );
  };

  return { Context, Provider };
};
